import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { actionBarActionSx, actionBarSx } from './ActionBar.style';
import {
  BottomNavigation,
  BottomNavigationAction,
  useTheme,
} from '@mui/material';
import { Add } from '../../icons/Add/Add';
import { Profile } from '../../icons/Profile/Profile';
import { Challenge } from '../../icons/Challenge/Challenge';
import { Copy } from '../../copy/Copy';
import { Community } from '../../icons/Community/Community';
import { useActionBarSelectHack } from '../../hooks/useActionBarSelectHack/useActionBarSelectHack';

export const ActionBar = () => {
  const theme = useTheme();
  const [value, setValue] = useState();
  const navigate = useNavigate();

  useActionBarSelectHack();

  const handleChange = (e, newValue) => {
    e.preventDefault();
    setValue(newValue);
    navigate(`/${newValue}`);
  };

  return (
    <BottomNavigation
      value={value}
      onChange={handleChange}
      showLabels
      sx={actionBarSx(theme)}
      component="nav"
    >
      <BottomNavigationAction
        id="profile"
        sx={actionBarActionSx(theme)}
        label={Copy.generate('Global.profile')}
        value="profile"
        icon={<Profile />}
      />

      <BottomNavigationAction
        id="community"
        sx={actionBarActionSx(theme)}
        label={Copy.generate('Global.community')}
        value="community"
        icon={<Community />}
      />

      <BottomNavigationAction
        id="add-activity"
        sx={actionBarActionSx(theme)}
        label={Copy.generate('Global.activity')}
        value="add-activity"
        icon={<Add />}
      />

      <BottomNavigationAction
        id="challenge"
        sx={actionBarActionSx(theme)}
        label={Copy.generate('Global.challenge')}
        value="challenge"
        icon={<Challenge />}
      />
    </BottomNavigation>
  );
};
